export interface CommitToast {
	duration: number;
	message: string;
	warning?: boolean;
}

// Long enough to read a sentence per group of roles the agent could not add, which the plain
// success toast never carries.
const BASELINE_NOTICE_TOAST_DURATION_MS = 15000;
const SUCCESS_TOAST_DURATION_MS = 5000;

/**
 * The toast shown once the agent has created the project. The modal closes at that point and
 * its chat goes with it, so roles the agent could not add to the Baseline are reported here.
 * They share the success toast rather than following it, because a second toast cuts the
 * first one short.
 */
export function buildCommitToast(successMessage: string, baselineNotices: string[]): CommitToast {
	if (baselineNotices.length === 0) {
		return {duration: SUCCESS_TOAST_DURATION_MS, message: successMessage};
	}
	return {
		duration: BASELINE_NOTICE_TOAST_DURATION_MS,
		warning: true,
		message: [successMessage, ...baselineNotices].join(' '),
	};
}
